import { refreshScrollTrigger } from './scroll-trigger.js';

function initHamburgerMenu(root) {
  const menuButton = root.querySelector('.l-menu-toggle');
  const menu = root.querySelector('.l-nav');
  const headerInner = root.closest('.l-header__inner');
  const headerLogo = headerInner?.querySelector('.logo__link svg');

  if (!menuButton || !menu || !headerLogo) {
    return null;
  }

  const setMenuOrigin = () => {
    const rect = menuButton.getBoundingClientRect();
    const x = rect.left + rect.width / 2;
    const y = rect.top + rect.height / 2;
    menu.style.setProperty('--menu-origin-x', `${x}px`);
    menu.style.setProperty('--menu-origin-y', `${y}px`);
  };

  const setMenuState = (isOpen) => {
    menuButton.classList.toggle('is-active', isOpen);
    menu.classList.toggle('is-open', isOpen);
    headerLogo.classList.toggle('is-white', isOpen);
    menuButton.setAttribute('aria-expanded', String(isOpen));
    menuButton.setAttribute('aria-label', isOpen ? 'メニューを閉じる' : 'メニューを開く');
    menu.setAttribute('aria-hidden', String(!isOpen));
    document.body.classList.toggle('is-menu-open', isOpen);

    requestAnimationFrame(() => {
      refreshScrollTrigger();
    });
  };

  menuButton.addEventListener('click', () => {
    setMenuOrigin();
    setMenuState(!menuButton.classList.contains('is-active'));
  });

  return { menuButton, setMenuOrigin, setMenuState };
}

export function initMenu() {
  const instances = [...document.querySelectorAll('.l-header .links__humberger')]
    .map(initHamburgerMenu)
    .filter(Boolean);

  if (!instances.length) {
    return;
  }

  window.addEventListener('resize', () => {
    instances.forEach(({ menuButton, setMenuOrigin }) => {
      if (menuButton.classList.contains('is-active')) {
        setMenuOrigin();
      }
    });
    refreshScrollTrigger();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') {
      return;
    }

    instances.forEach(({ menuButton, setMenuState }) => {
      if (menuButton.classList.contains('is-active')) {
        setMenuState(false);
      }
    });
  });
}
